<template>
    <div class="userInfoBox" :style="getBoxBackgroundImage(CharmLevelUserInfoData.current_level)">
        <div class="userImageBox">
            <!-- <img :src='CharmLevelUserInfoData.profile_images?.[0]?.image_name || "defaultUserImage"' alt="" /> -->
             <img :src="userImageSrc" :alt="CharmLevelUserInfoData.name || 'User avatar'" @error="onImgError" />
        </div>
        <div class="userNameBox">
            <div class="userNameTitle">{{ CharmLevelUserInfoData.name }}</div>
            <div class="userLabelBox">
                <img :src="getLevelImage(CharmLevelUserInfoData.current_level)" class="lavelImage" alt="level icon" />
                <span class="uaserLabelVal">{{ CharmLevelUserInfoData.current_level }}</span>
            </div>
        </div>
        <div class="user-rechargeLavelBox">
            <!-- <div class="recharge-title">Recharge</div> -->
            <div class="flexBox itemCemter">
                <div class="diamond-iconBox"><img :src='beansIcon' alt="" /></div>
                <div class="lavelVal">
                    {{
                        typeof CharmLevelUserInfoData.next_level_amount === 'number' && typeof
                            CharmLevelUserInfoData.earning_points === 'number'
                            ? (CharmLevelUserInfoData.next_level_amount !== 0
                                ? CharmLevelUserInfoData.next_level_amount - CharmLevelUserInfoData.earning_points
                                : CharmLevelUserInfoData.next_level_amount)
                            : 'Loading...'
                    }}
                    <!-- {{ CharmLevelUserInfoData.next_level_amount - CharmLevelUserInfoData.earning_points }} -->
                </div>
                <sub class="lavel-title">to level up</sub>
            </div>
            <div class="progressBarBox">                                
                <div class="progressBar-wrap">
                    <div class="pb-status charmLavel-pb-bg" :style="{ width: progressPercentage + '%' }">
                        <!-- <div class="ourValue">{{ CharmLevelUserInfoData.earning_points }}</div> -->
                    </div>
                </div>
                <div class="flexBox justify-content-between align-items-center mt-2 pb-lavelWrap">
                    <div class="pb-currentLavel">Lv {{ CharmLevelUserInfoData.current_level }}</div>
                    <div class="pb-nextLavel">Lv {{ CharmLevelUserInfoData.next_level }}</div>
                </div>
            </div>
            <!-- <div class="progressBar-wrap">
                <div class="pb-currentLavel">Lv {{ CharmLevelUserInfoData.current_level }}</div>
                <div class="pb-nextLavel">Lv {{ CharmLevelUserInfoData.next_level }}</div>
                <div class="pb-status charmLavel-pb-bg" :style="{ width: progressPercentage + '%' }">
                    <div class="ourValue">{{ CharmLevelUserInfoData.earning_points }}</div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import defaultUserImage from '../../assets/images/default_profile.webp'
import beansIcon from '../../assets/images/beansIcon.png'
export default {
    name: 'CharmLevelUserInfoComponent',
    data() {
        return {
            // CharmLevelUserInfoData: [],
            defaultUserImage,
            beansIcon,
            imgErrored: false,

            CharmLevelUserInfoData: {
                current_level: 1,
                next_level: 0,
                earning_points: 0,
                current_level_amount: 383690,
                next_level_amount: 0,

                 
                profile_images: []
            }
        }
    },
    computed: {
        userImageSrc() {
            if (this.imgErrored) return this.defaultUserImage // ✅ now defined
            const apiImg = this.CharmLevelUserInfoData?.profile_images?.[0]?.image_name
            return apiImg || this.defaultUserImage
        },
        progressPercentage() {
            const { earning_points, next_level_amount, next_level } = this.CharmLevelUserInfoData;
            if (next_level === 0) {
                return 100;
            }
            if (!earning_points || !next_level_amount) return 0;
            return 100 - ((next_level_amount - earning_points) * 100) / next_level_amount;
        },
    },
    mounted() {
        this.fetchCharmLeveUserInfolData();
    },
    watch: {
        '$route.params.profile_id': 'fetchCharmLeveUserInfolData'
    },
    methods: {
        onImgError(e) {
            this.imgErrored = true
            // stop infinite loops and swap to default
            e.target.onerror = null
            e.target.src = this.defaultUserImage
        },
        fetchCharmLeveUserInfolData() {
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/user-rich-charm-level-details?type=charm_level`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.CharmLevelUserInfoData = response.data.result.data;
                })
        //         .then(res => {
        //   const data = res?.data?.result?.data || {}
        //   this.imgErrored = false
        //   this.CharmLevelUserInfoData = {
        //     ...this.CharmLevelUserInfoData,
        //     ...data
        //   }
        // })

                .catch(error => {
                    console.error("Error Featching Charm Lavel Data", error)
                })
        },
        getLevelImage(charm_level) {
            switch (true) {
                case charm_level === 0:
                    return require('@/assets/images/charm-lavel-0.png');
                case charm_level === 1:
                    return require('@/assets/images/charm-lavel-1.png');
                case charm_level >= 2 && charm_level <= 5:
                    return require('@/assets/images/charm-lavel-2.png');
                case charm_level >= 6 && charm_level <= 10:
                    return require('@/assets/images/charm-lavel-4.png');
                case charm_level >= 11 && charm_level <= 15:
                    return require('@/assets/images/charm-lavel-5.png');
                case charm_level >= 16 && charm_level <= 20:
                    return require('@/assets/images/charm-lavel-6-10.png');
                case charm_level >= 21 && charm_level <= 25:
                    return require('@/assets/images/charm-lavel-11-15.png');
                case charm_level >= 26 && charm_level <= 30:
                    return require('@/assets/images/charm-lavel-16-20.png');
                // case charm_level === 0:
                //     return require('@/assets/images/charm-lavel-0.png');
                // case charm_level === 1:
                //     return require('@/assets/images/charm-lavel-1.png');
                // case charm_level === 2:
                //     return require('@/assets/images/charm-lavel-2.png');
                // case charm_level === 3:
                //     return require('@/assets/images/charm-lavel-3.png');
                // case charm_level === 4:
                //     return require('@/assets/images/charm-lavel-4.png');
                // case charm_level === 5:
                //     return require('@/assets/images/charm-lavel-5.png');
                // case charm_level >= 6 && charm_level <= 10:
                //     return require('@/assets/images/charm-lavel-6-10.png');
                // case charm_level >= 11 && charm_level <= 15:
                //     return require('@/assets/images/charm-lavel-11-15.png');
                // case charm_level >= 16 && charm_level <= 20:
                //     return require('@/assets/images/charm-lavel-16-20.png');
                default:
                    return require('@/assets/images/charm-lavel-0.png');
            }
        },
        getBoxBackgroundImage(charm_lavelBG) {
            switch (true) {
                case charm_lavelBG === 0:
                    return { backgroundImage: `url(${require('@/assets/images/charmBoxBg-lavel-0.png')})` };
                case charm_lavelBG === 1:
                    return { backgroundImage: `url(${require('@/assets/images/charmBoxBg-lavel-1.png')})` };
                case charm_lavelBG >= 2 && charm_lavelBG <= 5:
                    return { backgroundImage: `url(${require('@/assets/images/charmBoxBg-lavel-2-5.png')})` };
                case charm_lavelBG >= 6 && charm_lavelBG <= 10:
                    return { backgroundImage: `url(${require('@/assets/images/charmBoxBg-lavel-6-10.png')})` };
                case charm_lavelBG >= 11 && charm_lavelBG <= 15:
                    return { backgroundImage: `url(${require('@/assets/images/charmBoxBg-lavel-11-15.png')})` };
                case charm_lavelBG >= 16 && charm_lavelBG <= 20:
                    return { backgroundImage: `url(${require('@/assets/images/charmBoxBg-lavel-16-20.png')})` };
                default:
                    return { backgroundImage: `url(${require('@/assets/images/charmBoxBg-lavel-0.png')})` };
            }
        }
    },
}
</script>